/** Instance lookup for imperative services outside React. */
export function getInstanceIdFromUrl(): string | undefined {
  if (typeof window === 'undefined') return undefined
  return /^\/i\/([0-9a-f]{32})(?:\/|$)/.exec(window.location.pathname)?.[1]
}
